export default {
    label: {
        fontFamily: 'Lato',
        fontStyle: "normal",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "17px",
        color: "#262626",
        margin: "0px"
    },

    fontWeight700: {
        fontWeight: "700",
    },
    fontWeight600: {
        fontWeight: "600",
    },
    fontWeight500: {
        fontWeight: "500",
    },

    formLabel: {
        fontSize: "16px",
        color: "#676767",
        marginBottom: "8px",
        lineHeight: "20px",
    }
}